import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'
import { UserModel } from '../../../server/mpsklad_core/Models/UserModel'
import { useLogic } from '../../../hooks/storeHook'
import { MyRowProps } from '../../../types/tableTypes'
import { fixMsAppScrollProps } from '../../../common/msAppUtils'
import { CircularProgress, MenuItem, OutlinedInput, Select, TableCell } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ensureNumber, valuesOfNumericEnum } from '../../../common/tsUtils'
import { PaymentSource } from '../../../server/mpsklad_core/Entity/Enums/PaymentSource'
import { paymentSourceNames } from '../../../types/paymentSourceNames'

export const PaymentSourceCell =
  observer(
    ({row}: MyRowProps<UserModel>) => {
      const currentTypeValue = row.paymentSource

      const {setUserPaymentSource} = useLogic()

      const [isLoading, setIsLoading] = useState(false)

      const classes = useStyles()

      const onChange =
        async (value: unknown) => {
          const paymentSource: PaymentSource = ensureNumber(value)

          setIsLoading(true)

          try {
            await setUserPaymentSource(row.id, paymentSource)
          } catch (e) {
            console.log('Failed to change paymentSource', e)
          } finally {
            setIsLoading(false)
          }
        }

      return (
        <TableCell className={clsx('table-border', classes.cell)}>
          {
            isLoading
            ? <CircularProgress size={31}/>
            : <Select
              value={currentTypeValue}
              onChange={e => onChange(e.target.value)}
              MenuProps={fixMsAppScrollProps}
              fullWidth
              input={<OutlinedInput className={classes.input}/>}
            >
              {
                valuesOfNumericEnum(PaymentSource).map(value =>
                  <MenuItem key={value} value={value}>
                    {paymentSourceNames[value]}
                  </MenuItem>)
              }
            </Select>
          }
        </TableCell>
      )
    })

const useStyles = makeStyles(
  () => ({
    cell: {
      width: 100,
      backgroundColor: 'transparent',
      border: 'none',
      '& .MuiSelect-select:focus': {
        backgroundColor: 'transparent'
      },
      '& .MuiOutlinedInput-notchedOutline.Mui-focused': {
        border: '1px solid rgba(0, 0, 0, 0.23)'
      }
    },
    input: {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: '14.4px !important',
      textAlign: 'left',
      height: 35,
      '&.Mui-focused': {
        backgroundColor: 'transparent !important'
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px !important',
        borderColor: 'rgba(0, 0, 0, 0.23) !important'
      }
    },
    textField: {
      '& .Mui-disabled': {
        backgroundColor: '#fff',
        color: '#000'
      }
    },
    inputFocused: {
      backgroundColor: 'red !important'
    }
  }))